import { Request } from "../../../services/Request";
import { urls } from "../../../Utils/Urls";
import { getFarmerIdentity } from "./farmerIdentity";

const MIN_SEARCH_LENGTH = 3;

/**
 * Records a COMMITTED search into the logged-in farmer's recent-search history.
 *
 * Recording has no dedicated endpoint — it is a side-effect of the v3 global
 * search (`SearchService.saveFromSearch`), which attributes the search to the
 * identity in `RequestInfo.userInfo` ONLY (no criteria fallback). We route the
 * call through the public `?service=global_search` staticData gateway; the
 * gateway does `put("RequestInfo", top-level)` then `putAll(requestBody)`, so
 * the INNER `requestBody.RequestInfo` — the one carrying `userInfo` — wins the
 * merge and is what reaches `/search/v3`. Verified end-to-end on QA.
 *
 * This is intentionally NOT called from the live/debounced dropdown search
 * (that is browse-only and records nothing). It fires only when the farmer
 * commits to a query — picking a result, pressing Enter, or re-running a recent
 * search — so history holds whole, intentional terms rather than every partial
 * keystroke.
 *
 * `modules` scopes the recording search the same way as the caller's live search.
 *
 * Fire-and-forget: history is best-effort and must never block navigation.
 * Guests (no farmer identity) and sub-threshold queries are no-ops.
 */
export const recordCommittedSearch = (term, locale = "en", modules) => {
  const text = (term || "").trim();
  if (text.length < MIN_SEARCH_LENGTH) return;

  const farmer = getFarmerIdentity();
  if (!farmer) return;

  // Not awaited — Request() never rejects (it resolves the error response), so
  // this cannot produce an unhandled rejection.
  Request({
    url: urls.global_search,
    params: { service: "global_search" },
    data: {
      requestBody: {
        GlobalSearchCriteria: {
          type: "text",
          data: text,
          locale,
          ...(modules?.length ? { modules } : {}),
        },
        RequestInfo: {
          apiId: "dfs-web",
          ver: "1.0",
          action: "search",
          msgId: "record-search",
          userInfo: { uuid: farmer.uuid, tenantId: farmer.tenantId },
        },
      },
      requestParams: { tenantId: "br" },
    },
  });
};
